module.exports = __webpack_public_path__ + "static/media/sc4.0ad2bfdd.png";